import React, { useContext, useState } from "react";
import signupimage from '../../images/signup-g.svg'
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import api from "../../api"
import { UserContext } from "../../App";

const MyAccountSignUp = () => {
  const {setUser} = useContext(UserContext)
  const [fullname, setFullname] = useState("")
	const [email, setEmail] = useState("")
	const [phone, setPhone] = useState("")
	const [gender, setGender] = useState("")
	const [password, setPassword] = useState("")
	const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const handleSubmit = async (e) =>{
    e.preventDefault()
   if (password.length < 6) {
			setError("password must be atleast 6 characters")
			return
		}
		if (password !== confirmPassword) {
			setError("passwords don't match")
			return
		}
		// setLoading(true)

    const userData = {
      fullname,
      email, 
      phone, 
      gender, 
      password, 
      confirmPassword,
      verified:false,
    }

    const resp = await api.registerUser(userData)
		if (resp.status == "ok") {
			const loginResp = await api.loginUser(userData)
			if (loginResp.status == "ok") 
        {
				setUser(api.getUser())
				await api.createUserCart({
				    user: api.getUser(),
            // products: []  
					  products: cart?.products 
		    })
        navigate("/account")
				// if (cart?.products?.length) {
				// 	navigate("/cart")
				// } else {
				
				// }
			}
		}
    // const resp = await onSubmit({fullname, email, phone, gender, password, confirmPassword,verified})
		// setLoading(false)
		if (resp.status == "error" || resp.status == "400") {
			setError(resp.message)
		}
  }


  return (
    <div>
       <>
        <ScrollToTop/>
        </>
      <>
        {/* section */}
        <section className="my-lg-14 my-8">
          {/* container */}
          <div className="container">
            {/* row */}
            <div className="row justify-content-center align-items-center">
              <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2">
                {/* img */}
                <img
                  src={signupimage}
                  alt="freshcart"
                  className="img-fluid"
                />
              </div>
              {/* col */}
              <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1">
                <div className="mb-lg-9 mb-5">
                  <h1 className="mb-1 h2 fw-bold">Get Start Shopping</h1>
                  <p>Welcome to FreshCart! Enter your email to get started.</p>
                </div>
                {/* form */}
                <form
                onSubmit={handleSubmit}
                >
                  <div className="row g-3">
                    {/* col */}
                    <div className="col-12">
                      {/* input */}
                      <input
                        value={fullname}
                        type="text"
                        className="form-control"
                        placeholder="Full Name"
                        aria-label="Full Name"
                        onChange={e => setFullname(e.target.value)}
                        required
                      />
                    </div>
                      <div className="col-12">
                      {/* input */}
                      <input
                        value={email}
                        type="email"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Email"
                        onChange={e => setEmail(e.target.value)}
                        required
                      />
                    </div>
                      <div className="col">
                      {/* input */}
                      <input
                        value={phone}
                        type="text"
                        className="form-control"
                        placeholder="Phone"
                        aria-label="Phone"
                        onChange={e => setPhone(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col">
                      <select
                        className="form-select"
                        value={gender}
                        // placeholder="Gender"
                        aria-label="Gender"
                        onChange={e => setGender(e.target.value)}
                        required
                        defaultValue={""}
                      >
                      <option value="" disabled>
                        Select gender
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    </div>
                    <div className="col-12">
                      {/* input */}
                      <input
                        value={password}
                        type="password"
                        className="form-control"
                        id="inputPassword4"
                        placeholder="Password"
                        onChange={e => setPassword(e.target.value)}
                        required
                      />
                    </div>
                     <div className="col-12">
                      {/* input */}
                      <input
                        value={confirmPassword}
                        type="password"
                        className="form-control"
                        id="inputPassword5"
                        placeholder="Confirm Password"
                        onChange={e => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>
                    {/* btn */}
                    <div className="col-12 d-grid">
                      {" "}
                      <button type="submit" className="btn btn-primary">
                        Register
                      </button>
                      <span className="navbar-text">
                          Already have an account?{" "}

                          <Link to="/MyAccountSignIn">Sign in</Link>
                        </span>
                    </div>
                    {/* text */}
                    <p>
                      <small>
                        By continuing, you agree to our{" "}
                        <Link to="#!"> Terms of Service</Link> &amp;{" "}
                        <Link to="#!">Privacy Policy</Link>
                      </small>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </>
    </div>
  );
};

export default MyAccountSignUp;
